import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { MsalPlugin } from './plugins/msalWrapper'
import vuetify from './plugins/vuetify'

Vue.config.productionTip = false

const clientId = process.env.VUE_APP_CLIENT_ID
const authority = process.env.VUE_APP_AUTHORITY
const authorityDomain = process.env.VUE_APP_AUTHORITY_DOMAIN

Vue.use(MsalPlugin, {
  clientId,
  authority,
  authorityDomain,
  onRedirectCallback: (appState) => {
    router.push(appState && appState.state ? appState.state : window.location.pathname)
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: (h) => h(App)
}).$mount('#app')
